import { httpGet } from '../../../../components/utils';
import { InsuranceRules, InsuranceRulesOptions } from '../types/InsuranceRules';
import { useEffect, useState } from 'react';
import { HttpResponse } from '../../../../api/types/Http';

const UseGetInsuranceRuleOptions = () => {
    const [data, setData] = useState<InsuranceRules>();
    const [isFetching, setIsFetching] = useState(false);
    const [error, setError] = useState<string>();

    useEffect(() => {
        const getInsuranceRuleOptions = async () => {
            setIsFetching(true);
            setError(undefined);

            try {
                const httpResponse = (await httpGet(`/insights/getInsuranceRulesOptions`)) as unknown as HttpResponse<
                    InsuranceRulesOptions[]
                >;

                const rulesData = httpResponse.data;

                const newMapRulesNamesToIds = {};
                for (const rule of rulesData) {
                    if (newMapRulesNamesToIds[rule.name]) {
                        newMapRulesNamesToIds[rule.name].push(rule.id);
                    } else {
                        newMapRulesNamesToIds[rule.name] = [rule.id];
                    }
                }

                setData({
                    options: rulesData,
                    optionsKeysToValues: newMapRulesNamesToIds
                });
            } catch (err) {
                setError('Failed to get insurance rule options');
            }

            setIsFetching(false);
        };

        getInsuranceRuleOptions();
    }, []);

    return { data, isFetching, error };
};

export default UseGetInsuranceRuleOptions;
